module.exports = __webpack_public_path__ + "static/media/SCR-C-048.62584bc8.mp3";